module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAPCAYAAADUFP50AAAA50lEQVR42pXQvw4BQRAGcH8SKpGoVWq8AU+hUGll99yuWWdPVNdqT+INNKcRagWNN1DohVYpkZzZ5La6zOFLptjk++0kk8vKCKDFBWy5VEcm4GTHkZM5iZj02lyoO6IhFrsuTDt2EL9pJOHBx5OeeSMe4Cc3IbymeSOMyU0WuVrXTZFJtUqAhTQyCYKgYIpcwoVJOFiYiWwAoGYO4oZh2ff9Km5/pVFGtNYVJtSZj9XifyTVMtkGV0dA/x+UQLXmAjZRFBV/RfZqJcT7NKYRjWmUjc35CURjhDucJ4HoxHGcZzBrfOt9AGnLrxSQVO/XAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./resources/images/n-tag_1x.png
// module id = 2313
// module chunks = 0